$(document).ready(function (){
    // HERO SLIDER
    if ($(".hero-slider")[0]) {
        var menu = [];
        jQuery('.swiper-slide').each(function (index) {
            menu.push(jQuery(this).find('.slide-inner').attr("data-text"));
        });
        var interleaveOffset = 0.5;
        var swiperOptions = {
            loop: true,
            speed: 1000,
            parallax: true,
            // autoplay: {
            //     delay: 6500,
            //     disableOnInteraction: false,
            // },
            autoplay: false,
            watchSlidesProgress: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            on: {
                progress: function () {
                    var swiper = this;
                    for (var i = 0; i < swiper.slides.length; i++) {
                        var slideProgress = swiper.slides[i].progress;
                        var innerOffset = swiper.width * interleaveOffset;
                        var innerTranslate = slideProgress * innerOffset;
                        swiper.slides[i].querySelector(".slide-inner").style.transform =
                            "translate3d(" + innerTranslate + "px, 0, 0)";
                    }
                },

                touchStart: function () {
                    var swiper = this;
                    for (var i = 0; i < swiper.slides.length; i++) {
                        swiper.slides[i].style.transition = "";
                    }
                },

                setTransition: function (speed) {
                    var swiper = this;
                    for (var i = 0; i < swiper.slides.length; i++) {
                        swiper.slides[i].style.transition = speed + "ms";
                        swiper.slides[i].querySelector(".slide-inner").style.transition =
                            speed + "ms";
                    }
                }
            }
        };

        var swiper = new Swiper(".swiper-container", swiperOptions);
    }
// DATA BACKGROUND IMAGE
    var sliderBgSetting = $(".slide-bg-image");
    sliderBgSetting.each(function (indx) {
        if ($(this).attr("data-background")) {
            $(this).css("background-image", "url(" + $(this).data("background") + ")");
        }
    });

    if ($(".advantages-slider")[0]){
        let swiper = new Swiper(".advantages-slider", {
            spaceBetween: 30,
            slidesPerView: 'auto',
            pagination: {
                el: ".swiper-pagination",
                type: "fraction"
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }


//News swiper
    if ($(".swiper-news")[0]) {
        let swiperNews = new Swiper(".swiper-news", {
            spaceBetween: 30,
            slidesPerView: 3,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                // mobile + tablet - 320-990
                570: {
                    slidesPerView: 1,
                    spaceBetween: 30
                },
                991: {
                    slidesPerView: 2
                },
                // desktop >= 991
                1200: {
                    slidesPerView: 2,
                }
            }
        });
    }


    if ($(".swiper-reasons")[0]) {
        var init = false;

        function swiperCard() {
            if (window.innerWidth <= 768) {
                if (!init) {
                    init = true;
                    swiper = new Swiper(".swiper-reasons", {
                        direction: "horizontal",
                        slidesPerView: 1,
                        loopFillGroupWithBlank: false,
                        slidesPerColumn: 4,
                        slidesPerGroup: 1,
                        slidesPerColumnFill: "row",
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true,
                        },
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                    });
                }
            } else if (init) {
                swiper.destroy();
                init = false;
            }
        }
        swiperCard();
        window.addEventListener("resize", swiperCard);
    }
    if ($(".single-post-swiper")[0]){
        let swiper = new Swiper(".single-post-swiper", {
            spaceBetween: 30,
            slidesPerView: 'auto',
            pagination: {
                el: ".swiper-pagination",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }

})





